<template>
  <svg :aria-label="title" :width="width" :height="height" :class="{ large }" role="presentation">
    <title v-if="title" lang="nl">{{ title }}</title>
    <g :fill="color">
      <use
        v-bind="{
          'xlink:href': '/wwwroot/icons/icons.svg#' + icon,
        }"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      />
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    icon: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      default: null,
    },
    color: {
      type: String,
      default: 'currentColor',
    },
    width: {
      type: [Number, String],
      default: 24,
    },
    height: {
      type: [Number, String],
      default: 24,
    },
    large: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
svg {
  display: inline-block;
  fill: currentColor;
  color: currentColor;
  position: relative;

  &[disabled] {
    color: #a3b7c0;
  }
}

.large {
  width: 2rem;
  height: 2rem;
  vertical-align: -0.4em;
}
</style>
